import { IncomingTransferRequestListPage } from "@/features/transfer-request/pages/IncomingTransferRequestListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/incoming-transfer-request/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_request.view_incoming"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: IncomingTransferRequestListPage,
});
